module.exports = __webpack_public_path__ + "static/media/4.3e9fd95b.jpg";